export default "<div class=\"emplacement\">\n  {{EmplacementInComponent}}\n</div>\n\n";